import { render, staticRenderFns } from "./tender-stage.vue?vue&type=template&id=27848906&"
import script from "./tender-stage.vue?vue&type=script&lang=js&"
export * from "./tender-stage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports